import React from "react";
//#region types
import { TranslationKeys } from "translations";
//#endregion
//#region components
import { PageLayouts, useSearchContext } from "components/common";
import ReportNavigationContent from "./reportNavigationContent";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const ReportNavigation: React.FC = (props) => {
  const searchContext = useSearchContext();

  const onMenuItemSelect = () => {
    searchContext?.setSearchText(undefined);
  };

  return (
    <PageLayouts.NavigationLayout
      onSubMenuItemSelectHandler={onMenuItemSelect}
      navItems={[
        {
          navKey: "mainNav",
          title: "",
          content: <ReportNavigationContent />,
          menuSectionHeader: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Categories),
        },
      ]}
    />
  );
};

export default ReportNavigation;
